import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AuthGuard,
  CategoryPageMetaResolver,
  FeaturesConfigModule,
  I18nModule,
  UrlModule,
  provideConfig,
} from '@spartacus/core';
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
  PageSlotModule,
  ProductListModule,
  SpinnerModule,
  StarRatingModule,
  
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { KbProductGridItemModule } from '../kb-product-list/kb-product-grid-item/kb-product-grid-item.module';
import { KbProductListItemModule } from '../kb-product-list/kb-product-list-item/kb-product-list-item.module';
import { KbProductListModule } from '../kb-product-list/kb-product-list/kb-product-list.module';
import { CategoryGridItemComponent } from './category-grid-item/category-grid-item.component';
import { CategoryPageComponent } from './category-page/category-page.component';
import { KbCategoryPageMetaResolver } from './kb-category-page-meta.resolver';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';

@NgModule({
  declarations: [CategoryPageComponent, CategoryGridItemComponent],
  imports: [
    PageSlotModule,
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbProductListModule,
    KbProductGridItemModule,
    KbProductListItemModule,
    KbPaginationModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        CMSProductListComponent: {
          component: CategoryPageComponent,
        },
      },
    }),
    {
      provide: CategoryPageMetaResolver,
      useClass: KbCategoryPageMetaResolver,
    },
  ],
})
export class CategoryPageModule {}
